import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import closeIcon from "../../../../assets/closeModel.png";
import { useDispatch } from "react-redux";
import Validation from "../../../../utils/Validation";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import FormField from "../../../../components/common/FormField";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { useSelector } from "react-redux";

import { SUBCONTRACTOR_FORM_FIELDS } from "./subContractor";
import ResetFormAlert from "../../../../components/common/ResetFormAlert";
import {
  addSubContractorAction,
  getSingleSubContractorAction,
  intiaSubContractorLocalState,
} from "../../../../store/reducers/subContractor";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";

interface ManageSubContractorProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedRow: any; // Adjust type as per your requirement
  action?: any;
  setSelectedStaff?: any;
}

const ManageSubContractor: React.FC<ManageSubContractorProps> = ({
  open,
  onHide,
  title,
  selectedRow,
  action,
  setSelectedStaff,
}) => {
  const classes = useStyles();
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [formData, setFormData] = useState<any>(intiaSubContractorLocalState);

  const { subContractorDetails } = useSelector(
    (state: any) => state.subContractor
  );
  const [isChanged, setIsChanged] = useState(false);
    const [resetAlert, setResetAlert] = useState(false);
  const [alertModel, setAlertModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isClickReset, setIsClickReset] = useState(false);
  const [countryCodes, setCountryCodes] = useState<{ [key: string]: string }>({
    phone: "+44",
    emergencyPhone: "+44",
  });
  const [alertModeShow, setAlertModelShow] = useState(false);
  const [emailError, setEmailError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isErrorOptional,
    isError,
  ]: any = Validation({
    aka_name: formData?.aka_name,
    phone: formData?.phone,
  });

  useEffect(() => {
    if (selectedRow && open) {
      dispatch(getSingleSubContractorAction({ id: selectedRow }));
    }
  }, [selectedRow, open]);

  useEffect(() => {
    if (
      subContractorDetails &&
      Object.keys(subContractorDetails).length > 0 &&
      action === "edit"
    ) {
      const extractPhoneParts = (phone: string) => {
        if (!phone || !phone.startsWith("+")) {
          return { code: "+44", number: phone || "" };
        }
        const match = phone?.match(/^\+91|\+44/);
        if (match) {
          return { code: match[0], number: phone.replace(match[0], "") };
        }
        return { code: "+44", number: phone };
      };

      let updatedDetails: any = {
        ...subContractorDetails,
        skills:
          subContractorDetails.skills?.map((s: any) => ({
            id: s.id,
            name: s.name, // ✅ match FormMultiChipCheckbox
          })) || [],
      };

      // Phone
      if (subContractorDetails?.phone) {
        const { code, number } = extractPhoneParts(subContractorDetails.phone);
        updatedDetails.phone = number;
        setCountryCodes((prev) => ({ ...prev, phone: code }));
      }

      // Emergency Phone
      if (subContractorDetails?.emergency_contact_number) {
        const { code, number } = extractPhoneParts(
          subContractorDetails.emergency_contact_number
        );
        updatedDetails.emergency_contact_number = number;
        setCountryCodes((prev) => ({ ...prev, emergencyPhone: code }));
      }

      setFormData(updatedDetails); // ✅ single update
    }
  }, [subContractorDetails, action]);

  const handleCountryCodeChange = (field: string, value: string) => {
    setCountryCodes((prev) => ({ ...prev, [field]: value }));
    resetValidator(field);
  };

  const handleInputChange = (field: string, value: any) => {
    setFormData((prevState: any) => {
      if (field === "skills") {
        // Save array of objects directly
        return { ...prevState, skills: value };
      }
      return { ...prevState, [field]: value };
    });
    setIsChanged(true);
    if (field === "email") {
      setEmailError(null);
    }
    resetValidator(field);
  };

  const validateEmail = (email: string): string | null => {
    const trimmed = email?.trim() ?? "";
    if (trimmed === "") return null;
    if (/\s/.test(trimmed)) return "Please enter a valid Email";
    const position = trimmed.lastIndexOf("@");
    const indexOfDot = trimmed.lastIndexOf(".");
    if (position > 0 && indexOfDot > position && trimmed.length - position > 4) {
      return null;
    }
    return "Please enter a valid Email";
  };

  const onBlurAction = (event: any) => {
    const fieldID = event.target.id;
    if (fieldID === "email") {
      setEmailError(validateEmail(formData?.email));
      return;
    }
    if (
      formData[fieldID] !== "" &&
      formData[fieldID] !== null &&
      formData[fieldID] !== undefined
    ) {
      checkValidator(event.target.id);
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const emailErr = validateEmail(formData?.email);
    setEmailError(emailErr);
    checkValidator();
    if (!emailErr) {
      setIsActionCalled(true);
    }
  };

  const hideHandler = () => {
    if (isChanged) {
      setAlertModel(true);
      setAlertMessage(
        "Changes have been made. Are you sure you abandon the changes?"
      );
    } else {
      onHide();
      setFormData(intiaSubContractorLocalState);
      setIsChanged(false);
    }
    resetAllValidator();
    setEmailError(null);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setIsChanged(false);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        const finalPayload = {
          ...formData,
          phone: formData.phone ? `${countryCodes.phone}${formData.phone}` : "",
          emergency_contact_number: formData.emergency_contact_number
            ? `${countryCodes.emergencyPhone}${formData.emergency_contact_number}`
            : "",
        };
        if (
          action === "edit" &&
          selectedRow &&
          Object.keys(selectedRow).length > 0
        ) {
          dispatch(
            addSubContractorAction({
              id: selectedRow,
              ...finalPayload,
            })
          );
        } else {
          // remove id from payload
          const { id, ...rest } = finalPayload;
          dispatch(addSubContractorAction(rest));
        }
        setIsActionCalled(false);
      } else {
        console.log("error in form", error);
      }
      setIsChanged(false);
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleClear = () => {
    if (subContractorDetails?.id && action === "edit") {
      setFormData({ ...subContractorDetails });
    } else {
      setFormData(intiaSubContractorLocalState);
    }
    // setSelectedStaff(null);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();
    setEmailError(null);
    setIsClickReset(false);
    setIsChanged(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const resetFormData = () => {
     if (subContractorDetails?.id) {
       setFormData(subContractorDetails);
     } else {
       setFormData(intiaSubContractorLocalState);
     }
     setIsChanged(false);
     setResetAlert(false);
     setAlertModel(false);
   };
 
   const closeAlertModel = () => {
     setAlertModel(false);
     setResetAlert(false);
     onHide();
   };

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"md"}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              // style={{ right: 40 }}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText
            sx={{
              background: "#E5F4F1",
              padding: "10px 10px 10px 0px",
              border: "1px solid #CFCFCF",
              borderRadius: "5px",
            }}
          >
            <>
              <Notification />
              <Grid container spacing={1}>
                {SUBCONTRACTOR_FORM_FIELDS?.map((field, i) => {
                  let dynamicField = { ...field };
                  return (
                    <>
                      <FormField
                        key={field.id}
                        onPaste={(e: any) =>
                          field?.id === "name" || field?.id === "email"
                            ? ""
                            : e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (
                            [8, 9, 37, 38, 39, 40, 18, 17].includes(
                              event.keyCode
                            ) ||
                            event.ctrlKey
                          )
                            return event;
                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          } else if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(
                              event.target.value + event.key
                            )
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...dynamicField,
                          value: formData
                            ? formData[dynamicField.id]
                            : dynamicField.type === "multiSelectChip"
                            ? [] // default array for multi-select
                            : "",
                          inSingleGridForm: true,
                          minDate:
                            field.id === "movingOnDate"
                              ? new Date()
                              : undefined,
                          // maxDate:
                          //   field.id === "followUpDate"
                          //     ? newLeadLocal?.movingOnDate &&
                          //       dayjs(newLeadLocal.movingOnDate)
                          //         .toDate()
                          //     : undefined,
                          variant: "outlined",
                          // ✅ Pass the current country code to FormField
                          countryCode:
                            field.type === "contact"
                              ? countryCodes[field.id]
                              : undefined,
                          // ✅ make it dynamic instead of hardcoded
                          onCountryCodeChange:
                            field.type === "contact"
                              ? (val: string) =>
                                  handleCountryCodeChange(field.id, val)
                              : undefined,
                          onChange: (value: any) => {
                            if (
                              Array.isArray(value) &&
                              field.type === "multiSelectChip"
                            ) {
                              // For FormMultiChipCheckbox (multiSelectChip)
                              handleInputChange(field.id, value);
                            } else {
                              // For normal inputs (event)
                              handleInputChange(
                                field.id,
                                value?.target?.value ?? value
                              );
                            }
                          },
                          onBlur: onBlurAction,
                          isNonMarginTop: true,
                          GridFieldStyle: {
                            paddingLeft:
                              field.type === "daterangebothvalue" ||
                              field.type === "date"
                                ? "8px !important"
                                : "auto",
                          },
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx:
                              field.type === "text" || field.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                          error: field.id === "email" ? emailError : (error && error[field.id]),
                        }}
                      />
                    </>
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alertModeShow && (
        <ResetFormAlert
          open={alertModeShow}
          title=""
          alertModalShow={alertModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
       {alertMessage && (
              <AlertPopup
                open={alertModel}
                // onClose={() => setAlertModel(false)}
                title="Alert"
                content={alertMessage}
                submitHandler={() => {
                  resetAlert ? resetFormData() : closeAlertModel();
                }}
                onHide={() => setAlertModel(false)}
                isError={false}
              />
            )}
    </>
  );
};

export default ManageSubContractor;
